import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getToken, clearToken } from "../../utils/auth";

const API = process.env.REACT_APP_API_URL || window.location.origin;

export default function BeansSection() {
    const nav = useNavigate();
    const token = getToken();
    const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

    const [beans, setBeans] = useState([]);
    const [name, setName] = useState("");
    const [file, setFile] = useState(null);
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const [editId, setEditId] = useState(null);
    const [editName, setEditName] = useState("");

    const load = async () => {
        try {
            const r = await fetch(`${API}/api/beans`);
            const data = await r.json().catch(() => []);
            setBeans(Array.isArray(data) ? data : []);
        } catch {
            setBeans([]);
        }
    };

    useEffect(() => {
        if (!token) {
            nav("/admin");
            return;
        }
        load();
        // eslint-disable-next-line
    }, []);

    const uploadImage = async () => {
        const fd = new FormData();
        fd.append("image", file);

        const r = await fetch(`${API}/api/upload`, {
            method: "POST",
            headers: { ...authHeaders },
            body: fd,
        });

        const text = await r.text();
        let data = {};
        try {
            data = JSON.parse(text);
        } catch {}

        if (!r.ok) {
            throw new Error(data?.error || "Upload başarısız");
        }

        return data.imageUrl;
    };

    const addBean = async (e) => {
        e.preventDefault();
        setErr("");

        if (!name.trim()) {
            return setErr("Çekirdek adı zorunlu");
        }

        try {
            setBusy(true);

            let imageUrl = null;
            if (file) {
                imageUrl = await uploadImage();
            }

            const r = await fetch(`${API}/api/beans`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...authHeaders,
                },
                body: JSON.stringify({
                    name: name.trim(),
                    imageUrl,
                }),
            });

            const data = await r.json().catch(() => ({}));

            if (r.status === 401) {
                clearToken();
                nav("/admin");
                return;
            }

            if (!r.ok) {
                throw new Error(data?.error || "Çekirdek eklenemedi");
            }

            setName("");
            setFile(null);
            await load();
        } catch (error) {
            setErr(error.message || "Bir hata oluştu");
        } finally {
            setBusy(false);
        }
    };

    const delBean = async (id) => {
        if (!window.confirm("Bu çekirdeği silmek istediğine emin misin?")) return;

        try {
            const r = await fetch(`${API}/api/beans/${id}`, {
                method: "DELETE",
                headers: { ...authHeaders },
            });

            if (r.status === 401) {
                clearToken();
                nav("/admin");
                return;
            }

            const data = await r.json().catch(() => ({}));
            if (!r.ok) {
                throw new Error(data?.error || "Çekirdek silinemedi");
            }

            await load();
        } catch (error) {
            setErr(error.message || "Bir hata oluştu");
        }
    };

    const startEdit = (item) => {
        setEditId(item.id);
        setEditName(item.name || "");
        setErr("");
    };

    const cancelEdit = () => {
        setEditId(null);
        setEditName("");
        setErr("");
    };

    const saveBean = async () => {
        setErr("");

        if (!editName.trim()) {
            return setErr("Çekirdek adı zorunlu");
        }

        try {
            setBusy(true);

            const r = await fetch(`${API}/api/beans/${editId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    ...authHeaders,
                },
                body: JSON.stringify({
                    name: editName.trim(),
                }),
            });

            const data = await r.json().catch(() => ({}));

            if (r.status === 401) {
                clearToken();
                nav("/admin");
                return;
            }

            if (!r.ok) {
                throw new Error(data?.error || "Çekirdek güncellenemedi");
            }

            setEditId(null);
            setEditName("");
            await load();
        } catch (error) {
            setErr(error.message || "Bir hata oluştu");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div style={{ marginTop: 30 }}>
            {err ? (
                <div className="adminError" style={{ marginBottom: 16 }}>
                    {err}
                </div>
            ) : null}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "minmax(320px, 420px) 1fr",
                    gap: "24px",
                    alignItems: "start",
                }}
            >
                <div className="adminCard">
                    <h3 className="adminH3">Çekirdek Ekle</h3>

                    <form className="adminForm" onSubmit={addBean}>
                        <input
                            className="adminInput"
                            placeholder="Çekirdek adı"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />

                        <input
                            className="adminInput"
                            type="file"
                            accept="image/*"
                            onChange={(e) => setFile(e.target.files?.[0] || null)}
                        />

                        <small style={{ color: "#777", marginTop: "-6px" }}>
                            Resim zorunlu değil
                        </small>

                        <button className="adminBtn" type="submit" disabled={busy}>
                            {busy ? "Ekleniyor..." : "Çekirdek Ekle"}
                        </button>
                    </form>
                </div>

                <div className="adminCard">
                    <h3 className="adminH3">Çekirdekler</h3>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                            gap: "18px",
                        }}
                    >
                        {beans.map((item) => (
                            <div
                                key={item.id}
                                style={{
                                    border: "1px solid #eee",
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    background: "#fff",
                                    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                }}
                            >
                                <div
                                    style={{
                                        height: "180px",
                                        background: "#f7f7f7",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {item.imageUrl ? (
                                        <img
                                            src={`${API}${item.imageUrl}`}
                                            alt={item.name}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : (
                                        <div
                                            style={{
                                                width: 64,
                                                height: 64,
                                                borderRadius: "50%",
                                                background: "#8b5e3c",
                                                color: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontSize: 26,
                                                fontWeight: 700,
                                            }}
                                        >
                                            {item.name?.charAt(0)?.toUpperCase() || "?"}
                                        </div>
                                    )}
                                </div>

                                <div style={{ padding: "14px" }}>
                                    {editId === item.id ? (
                                        <div style={{ marginBottom: "14px" }}>
                                            <input
                                                className="adminInput"
                                                value={editName}
                                                onChange={(e) => setEditName(e.target.value)}
                                                style={{ marginBottom: "10px" }}
                                            />

                                            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                                <button
                                                    className="adminBtn"
                                                    type="button"
                                                    disabled={busy}
                                                    onClick={saveBean}
                                                >
                                                    Tamam
                                                </button>

                                                <button
                                                    className="adminBtnOutline"
                                                    type="button"
                                                    onClick={cancelEdit}
                                                >
                                                    İptal
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                fontSize: "18px",
                                                fontWeight: 700,
                                                marginBottom: "14px",
                                            }}
                                        >
                                            {item.name}
                                        </div>
                                    )}

                                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                        {editId !== item.id ? (
                                            <button
                                                className="adminBtnOutline"
                                                type="button"
                                                onClick={() => startEdit(item)}
                                            >
                                                Düzenle
                                            </button>
                                        ) : null}

                                        <button
                                            className="adminDanger"
                                            type="button"
                                            onClick={() => delBean(item.id)}
                                        >
                                            Sil
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {beans.length === 0 ? (
                        <div style={{ color: "#666", marginTop: 12 }}>
                            Henüz çekirdek yok.
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}